import Vue from 'vue'
import Router from 'vue-router'


// import pages
import Create from '@/components/pages/create'
import QuoteSummary from '@/components/pages/QuoteSummary';
import QuoteReview from '@/components/pages/QuoteReview';
import QuoteRequestedSuccess from '@/components/pages/QuoteRequestedSuccess';
import LoginAndRegister from '@/components/pages/LoginAndRegister';
import Login from '@/components/pages/Login';
// import Design from '@/components/pages/Design';
import ResetPassword from '@/components/pages/ResetPassword';
import Dashboard from '@/components/pages/Dashboard';
import DashboardQuotations from '@/components/pages/DashboardQuotations';
import DashboardSurveys from '@/components/pages/DashboardSurveys';
import DashboardEditAccount from '@/components/pages/DashboardEditAccount';
import DashboardCompletedSurveys from '@/components/pages/DashboardCompletedSurveys';
import CreataAreaDetailsPanel from '@/components/pages/CreateAreaDetailsPanel';
import CreateAreaReviewPanel from '@/components/pages/CreateAreaReviewPanel'
import CreateSelectAnArea from '@/components/pages/CreateSelectAnArea';
import QuoteCheckout from '@/components/pages/QuoteCheckout';
import SendPurcahseOrder from '@/components/pages/SendPurcahseOrder';
import FourOhFourPage from '@/components/pages/FourOhFourPage'
import ShareDownloadSurveyReport from '@/components/pages/ShareDownloadSurveyReport';

Vue.use(Router)


import $store from '../store';

const router = new Router({
  mode: 'history',
  routes: [
    {
      path : '/',
      beforeEnter : (to, from, next) => {
        let query = to.query.pcode ? '?pcode=' + to.query.pcode : ''
        next({path : '/create/select-area' + query});
      }
    },
    {

      path: '/create',
      name: 'Topographical',
      component: Create,
      redirect : '/create/select-area',
      children : [
        {
          path: 'select-area',
          name: 'Select an Area',
          component : CreateSelectAnArea,
          beforeEnter : (to, from, next) => {
            if(from.path !== '/create/area-details'){
              $store.commit('resetCreateArea');
              next();
            } else {
              next();
            }
          }
        },
        {
          path : 'area-details',
          name : 'Area Details',
          component : CreataAreaDetailsPanel,
          beforeEnter : (to, from, next) => {
            if($store.state.createArea.mapData.polygonsList.length > 0){
              next();
            }
          }
        },
        {
          path: 'review-areas',
          name: 'Review an area',
          component : CreateAreaReviewPanel,
          beforeEnter : (to, from, next) => {
              $store.dispatch('getLocalStoredAreas')
              .then((canEnter) => {
                 if(canEnter){
                   next();
                 } else {
                  next({path : '/'})
                 }
              })
              .catch((err) => {
                 next({path : '/'})
              })
          } 
        }
      ]
    },
    {
      path : '/create/quote-summary',
      name : 'Quote Summary',
      component : QuoteSummary,
      meta: { requiresAuth: true},
      beforeEnter : (to, from, next) => {
          if(!$store.getters.savedAreas.length){
            next({path : '/create/select-area'});
          } else {
            next();
          }
      }
    },
    {
      path : '/create/checkout/:id',
      name : 'Check out',
      component : QuoteCheckout,
      meta : {requiresAuth : true}
    },
    {
      path : '/create/quote-requested',
      name : 'Quote Request Successful',
      component : QuoteRequestedSuccess,
      meta: { requiresAuth: true}
    },
    {
      path : '/purchase-order-number/:id',
      name : 'Send purchase order',
      component : SendPurcahseOrder,
      meta: { requiresAuth: true}
    },
    {
      path : '/create/quote-review',
      name : 'Quote review and payment',
      component : QuoteReview,
      meta: { requiresAuth: true}
    },
    {
      path : '/login-or-register',
      name : 'Login or Register',
      component : LoginAndRegister,
      beforeEnter: (to, from, next) => {
        if (!$store.getters.isLoggedIn){
          next();
        } else {
          next({
            path: from.fullPath
          });
        }
      }
    },
    {
      path : '/user/forgotpassword',
      name : 'Reset password',
      component : ResetPassword,
      beforeEnter: (to, from, next) => {
        if (!$store.getters.isLoggedIn){
          next();
        } else {
          next({
            path: from.fullPath
          });
        }
      }
    },
    {
      path : '/dashboard',
      component : Dashboard,
      meta: { requiresAuth: true},
      children : [
        {
          path : '',
          name : 'dashboard',
          component : DashboardQuotations
        },
        {
          path : 'quotations',
          name : 'quotations',
          component : DashboardQuotations
        },
        {
          path : 'surveys',
          name : 'surveys',
          component : DashboardSurveys
        },
        {
          path : 'editaccount',
          name : 'editaccount',
          component : DashboardEditAccount
        },
        {
          path : 'completed',
          name : 'completed',
          component : DashboardCompletedSurveys
        }
      ]
    },
    {
      path : '/login',
      name : 'Login',
      component : Login,
      
    },

    // {
    //   path : '/Design',
    //   name : 'Design',
    //   component : Design,
      
    // },
  
    {
      path : '/s/:id',
      name : 'Download Survey Report',
      component : ShareDownloadSurveyReport
    },
    {
      path : '/*',
      name : '404 - page not found',
      component : FourOhFourPage
    }
  ]
})


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    
    if (!$store.getters.isLoggedIn){ // return true if no user found
      next({
        path: '/login-or-register',
        query: {
          redirect: to.fullPath,
        },
      });
    } else {
      next();
    }
  } else {
    next();
  }

})

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js